var map = {
	"./1.svg": 14390,
	"./104490_apple_icon.svg": 78234,
	"./3251292_advanture_camp_camping_guitar_music_icon.svg": 20074,
	"./3406425_animal_bunny_domestic_mammal_pet_icon.svg": 10525,
	"./3669395_call_ic_icon.svg": 83577,
	"./3671715_box_icon.svg": 98944,
	"./4K.svg": 96575,
	"./6602434_angle_design_graphic_icon.svg": 28012,
	"./6623003_airplane_fly_holidays_plane_summer_icon.svg": 21144,
	"./753922_theatre_entertainment_film_movie_theater_icon.svg": 56203,
	"./7830770_binocular_icon.svg": 68752,
	"./8541713_crown_icon.svg": 95623,
	"./8664959_car_rear_icon.svg": 56497,
	"./8665433_fire_flame_curved_icon.svg": 3606,
	"./8665722_money_bill_1_icon.svg": 74419,
	"./8665779_link_connection_icon.svg": 10930,
	"./8666788_info_information_icon.svg": 9440,
	"./8666809_flag_location_icon.svg": 87423,
	"./8678526_bug_line_insect_icon.svg": 42254,
	"./9004776_smart_watch_clock_time_icon.svg": 30827,
	"./9025778_paint_brush_icon.svg": 77612,
	"./9034830_cube_icon.svg": 61380,
	"./9035384_hammer_outline_icon.svg": 22602,
	"./9039985_calendar2_check_icon.svg": 19606,
	"./9040022_briefcase_icon.svg": 52164,
	"./9040095_fan_icon.svg": 73925,
	"./9040166_dice_icon.svg": 66471,
	"./9040215_clock_icon.svg": 91114,
	"./9040252_envelope_icon.svg": 73686,
	"./9040318_gear_icon.svg": 39212,
	"./9040339_folder2_open_icon.svg": 61259,
	"./9040343_handbag_icon.svg": 28999,
	"./9040375_filetype_doc_icon.svg": 13680,
	"./9040388_funnel_icon.svg": 87226,
	"./9040393_instagram_icon.svg": 14036,
	"./9040463_mic_icon.svg": 24858,
	"./9040495_flower3_icon.svg": 59167,
	"./9040514_music_player_icon.svg": 40247,
	"./9040546_palette2_icon.svg": 26619,
	"./9040552_scissors_icon.svg": 83670,
	"./9040568_puzzle_icon.svg": 28974,
	"./9040674_thermometer_sun_icon.svg": 44707,
	"./9040725_robot_icon.svg": 28388,
	"./9040751_signpost_2_icon.svg": 84199,
	"./9040756_star_icon.svg": 98164,
	"./9040783_snow_icon.svg": 40397,
	"./9040800_vector_pen_icon.svg": 89706,
	"./9040828_truck_icon.svg": 76972,
	"./9040857_wifi_2_icon.svg": 25440,
	"./9041221_gear_wide_connected_icon.svg": 55311,
	"./9055125_bxs_bookmark_icon.svg": 20556,
	"./9111165_player_play_pause_icon.svg": 6539,
	"./Camada 2.svg": 37540,
	"./Group 65579.svg": 58830,
	"./Layer 2.svg": 62863,
	"./Layer 25.svg": 63311,
	"./Layer 56.svg": 31848,
	"./Layer_1.svg": 84698,
	"./Path 34505.svg": 99216,
	"./_icons.svg": 48158,
	"./about.svg": 72989,
	"./balloon_icon.svg": 94168,
	"./bell_icon.svg": 93104,
	"./book_icon.svg": 23382,
	"./brightness_high_icon.svg": 74580,
	"./camera2_icon.svg": 18705,
	"./camera_reels_icon.svg": 65605,
	"./cart_dash_icon.svg": 63696,
	"./cloud_check_icon.svg": 4677,
	"./cloud_sun_icon.svg": 31382,
	"./controller_icon.svg": 85084,
	"./cup_straw_icon.svg": 53856,
	"./edit_mode_icon.svg": 32245,
	"./eye_icon.svg": 69006,
	"./film_icon.svg": 74803,
	"./gift_icon.svg": 937,
	"./globe_icon.svg": 54039,
	"./headset_icon.svg": 64296,
	"./hourglass_bottom_icon.svg": 59031,
	"./house_icon.svg": 35756,
	"./human resource.svg": 25943,
	"./image_icon.svg": 64267,
	"./incognito_icon.svg": 72861,
	"./lamp_icon.svg": 4466,
	"./lightbulb_icon.svg": 72956,
	"./lightning_charge_icon.svg": 59100,
	"./magic_icon.svg": 30555,
	"./moon_stars_icon.svg": 84748,
	"./mortarboard_icon.svg": 29931,
	"./music_note_beamed_icon.svg": 10139,
	"./music_note_icon.svg": 52763,
	"./paint_bucket_icon.svg": 30413,
	"./palette_icon.svg": 16062,
	"./phone_icon.svg": 25119,
	"./piggy_bank_icon.svg": 53653,
	"./pin_icon.svg": 41092,
	"./pin_map_icon.svg": 40721,
	"./play_circle_icon.svg": 52733,
	"./plug_cable_icon.svg": 33250,
	"./star_half_icon.svg": 95819,
	"./toggles_icon.svg": 21799,
	"./trash3_icon.svg": 47988
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23512;